module.exports = __webpack_public_path__ + "static/media/kv-ja.1516c991.jpg";